<script>
  import Tooltip from "../Tooltip/Tooltip.svelte";

  export let section = "";
  export let breadcrumb = "";
  export let area = "";
  export let areaHref = "";
  export let areaClickable = true;
  export let projectHref = "";
  export let projectNameOverride = "";
  export let hideProjectName = false;
  export let tooltipText = "";
  export let showTooltip = true;
  export let updatePageTitle = true;
  export let breadcrumbsClickable = true;
  export let paddingRight = true;
  export let onProjectClick = null;
  export let onAreaClick = null;
  export let onPageTitleUpdate = null;

  $: if (updatePageTitle && onPageTitleUpdate) {
    onPageTitleUpdate({ section, breadcrumb });
  }
  $: displayedProject = hideProjectName ? "" : projectNameOverride;
  $: displayedProjectName =
    displayedProject.length > 20
      ? `${displayedProject.slice(0, 20)}...`
      : displayedProject;

  function openProjectOverview() {
    if (onProjectClick) {
      onProjectClick();
      return;
    }
  }

  function openArea() {
    if (!areaClickable) return;
    if (onAreaClick) {
      onAreaClick();
      return;
    }
  }
</script>

<div class:no-padding-right="{!paddingRight}" class="header_wrapper">
  <div class="header_breadcrumb">
    {#if area || tooltipText}
      {#if displayedProject}
        <button
          type="button"
          class="breadcrumb_link bold"
          on:click={openProjectOverview}
          disabled={!breadcrumbsClickable || (!projectHref && !onProjectClick)}
          title={displayedProject}
        >
          {displayedProjectName}
        </button>
        {#if area || breadcrumb}<div class="breadcrumb_separator">/</div>{/if}
      {/if}
      {#if area}
        <button
          type="button"
          class="breadcrumb_link bold"
          on:click={openArea}
          disabled={!breadcrumbsClickable || !areaClickable || (!areaHref && !onAreaClick)}
        >
          {area}
        </button>
        {#if breadcrumb}<div class="breadcrumb_separator">/</div>{/if}
      {/if}
      {#if breadcrumb}<div class="breadcrumb_current">{breadcrumb}</div>{/if}
      {#if showTooltip && tooltipText}
        <Tooltip text={tooltipText} />
      {/if}
    {:else}
      {#if displayedProject}
        <div class="header_breadcrumb bold" title={displayedProject}>{displayedProjectName}</div>
        {#if section || breadcrumb}<div class="breadcrumb_separator">/</div>{/if}
      {/if}
      {#if section}
        <div class="breadcrumb_section bold">{section}</div>
        {#if breadcrumb}<div class="breadcrumb_separator">/</div>{/if}
      {/if}
      {#if breadcrumb}<div class="breadcrumb">{breadcrumb}</div>{/if}
      {#if showTooltip && tooltipText}
        <Tooltip text={tooltipText} />
      {/if}
    {/if}
  </div>
  <div class="header_functions">
    <slot />
  </div>
</div>

<style>
  .header_wrapper {
    background-color: var(--pax-white);
    border-bottom: var(--bw) solid var(--border-color);
    position: fixed;
    top: 0;
    left: var(--app-side-nav-width);
    width: calc(100vw - var(--app-side-nav-width));
    display: flex;
    z-index: var(--z10);
    height: var(--app-header-height);
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }

  .header_wrapper.no-padding-right {
    padding-right: 0;
  }

  .header_wrapper:has(:global(.header_filter_content)) {
    padding-right: 0;
  }

  .header_breadcrumb {
    display: flex;
    gap: 0.3rem;
    align-items: center;
    line-height: 1.25;
    overflow: visible;
  }

  .header_functions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .header_functions :global(.button_wrapper) {
    width: 2.5rem !important;
    height: 2.5rem !important;
    min-height: 2.5rem !important;
  }

  .header_functions :global(.source_menu),
  .header_functions :global(.source_menu .bx--overflow-menu),
  .header_functions :global(.source_menu .bx--overflow-menu__trigger),
  .header_functions :global(.source_menu_trigger),
  .header_functions :global(.bx--select),
  .header_functions :global(.bx--select-input__wrapper),
  .header_functions :global(.custom_select .bx--select-input) {
    /* 1px shorter than the header so its bottom border stays visible,
       same as .header_filter_button in Filter.svelte */
    height: calc(var(--app-header-height) - 1px) !important;
    min-height: calc(var(--app-header-height) - 1px) !important;
  }

  .breadcrumb_link {
    max-width: 12rem;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    cursor: pointer;
    font: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: inherit;
  }

  /* .bold {
    font-weight: bold;
  } */

  .breadcrumb {
    margin-left: 0.5rem;
    line-height: inherit;
  }

  .breadcrumb_section {
    margin-left: 0.5rem;
    line-height: inherit;
  }

  .breadcrumb_link:disabled {
    cursor: default;
  }

  .breadcrumb_link:not(:disabled):hover {
    text-decoration: underline;
    text-underline-offset: 0.12em;
  }

  .breadcrumb_separator {
    color: var(--pax-grey);
    line-height: inherit;
  }

  .breadcrumb_current {
    margin-left: 0;
    line-height: inherit;
  }
</style>
